import { IBrandOrder } from "@faire/web-api--source/indigofair/data/IBrandOrder";

export const isBrandOrderBackordered = (selectedBrandOrder: IBrandOrder) => {
  return (
    selectedBrandOrder.state === IBrandOrder.State.BACKORDERED ||
    selectedBrandOrder.exception_reason ===
      IBrandOrder.ExceptionReason.BACKORDERED_ITEMS ||
    selectedBrandOrder.backordered_at
  );
};
